import { get } from "utilities/network";

export const httpGetAdmin = () => {
  return get("admin/auth/me");
};
